import React from "react";
import { Box, Typography } from "@mui/material";
import { Button } from "@dishopsaas/design-system";
import * as styles from "../AccountForm.styles";
export const HeaderSection = ({
  onClick,
  loading,
  label,
  buttonName,
  leftIcon,
  colorType,
}: any) => (
  <Box sx={styles.headerBox}>
    <Typography variant="h5">{label}</Typography>
    <Button
      label={buttonName}
      colorType={colorType}
      onClick={onClick}
      loading={loading}
      leftIcon={leftIcon}
      height={36}
      iconOptions={{ size: 16 }}
    ></Button>
  </Box>
);
